export enum GATEWAYS_AGGREGATED_STATUS {
  CONNECTED = 'CONNECTED',
  PARTIALLY_DISCONNECTED = 'PARTIALLY_DISCONNECTED',
  DISCONNECTED = 'DISCONNECTED',
  NO_GATEWAYS = 'NO_GATEWAYS',
  NO_GATEWAY_CONNECTORS = 'NO_GATEWAY_CONNECTORS',
  MISCONFIGURATION = 'MISCONFIGURATION'
}
